/** @jsxImportSource @emotion/react */
import {
  DialogTitle,
  DialogContent,
  DialogFooter,
} from '../../../../components/Dialog';
import {Dialog} from '@reach/dialog';
import Img from './FailImg.svg';
import Button, {ButtonGroup} from '../../../../components/Button';

type Props = {
  onCancel?: () => void;
  onConfirm?: () => void;
  isOpen?: boolean;
  text?: React.ReactNode;
};
export default function FailDialog(props: Props) {
  const {isOpen, text, onCancel, onConfirm} = props;
  return (
    <Dialog isOpen={isOpen} className={'fail-dialog'} aria-label="fail-dialog">
      <DialogTitle title="資料未正確" onClose={onCancel} showCloseButton />
      <DialogContent>
        <p css={{marginTop: 16, fontSize: 15, lineHeight: 2}}>
          {text ? (
            text
          ) : (
            <span>
              尚有欄位中的資料未填寫正確，點選確定後，
              <br />
              請協助修正紅色提示字欄位內容。
            </span>
          )}
        </p>
        <img
          alt="failImg"
          src={Img}
          css={{marginTop: 15, marginBottom: 40, marginRight: 75}}
        />
      </DialogContent>
      <DialogFooter>
        <ButtonGroup>
          <Button variant={'cta'} onClick={onConfirm} className={'confirm-btn'} aria-label="confirm-btn">
            確定
          </Button>
        </ButtonGroup>
      </DialogFooter>
    </Dialog>
  );
}
